import React, {ReactNode} from 'react';
import {FatOutlineButton} from './FatOutlineButton';


type FatAtlantisOutlineButtonProps = {
    onClick?: () => void;
    type?: 'submit' | 'reset' | 'button';
    text: string;
    icon?: ReactNode;
}
export const FatAtlantisOutlineButton = ({text, onClick, type = 'button', icon}: FatAtlantisOutlineButtonProps) => {
    return <FatOutlineButton text={text} onClick={onClick} type={type} color="atlantis" icon={icon}/>;
}
